import { PRELOADING } from "./action";

const initialState = {
    isPreloading: false,
}
const preloaderReducer = (state = initialState, action) => {
    switch (action.type) {
        case PRELOADING:
            return state = {
                ...state,
                isPreloading: action.isPreloading
            }
        default: return state
    }
};

export default preloaderReducer;